class FaqCategory extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.faqc-item'));

    // Single-open on load: keep only the first item marked open, close the rest.
    let kept = false;
    this.items.forEach((item) => {
      const summary = item.querySelector('.faqc-item__summary');
      if (item.classList.contains('is-open')) {
        if (kept) {
          item.classList.remove('is-open');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        } else {
          kept = true;
        }
      }
      if (summary) summary.addEventListener('click', () => this.toggle(item));
    });
  }

  toggle(target) {
    const willOpen = !target.classList.contains('is-open');

    // Single-open: close every item first.
    this.items.forEach((item) => {
      item.classList.remove('is-open');
      const summary = item.querySelector('.faqc-item__summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });

    if (willOpen) {
      target.classList.add('is-open');
      const summary = target.querySelector('.faqc-item__summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }
  }
}

if (!customElements.get('faq-category')) {
  customElements.define('faq-category', FaqCategory);
}
